<!--modal custom wrapper-->
<div class="ces-modal-popup-wrapper">
  <!--modal header-->
  <div class="k-window-titlebar k-dialog-titlebar">
    <div class="k-window-title k-dialog-title">Change Your Password</div>
    <div class="k-window-actions k-dialog-actions">
      <button
        type="button"
        class="ces-button ces-button-small ces-button-ghost-secondary modal-close-btn"
        (click)="dismiss()"
      >
        <span class="k-button-icon k-icon k-i-x"></span>
      </button>
    </div>
  </div>
  <!--modal content-->
  <div class="k-content k-window-content k-dialog-content ces-form-component end-job-mnodal">
    <form [formGroup]="pwdForm">
      <div class="row job-row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="ces-form-group required">
            <label class="ces-label ces-label-2 ces-text-medium"
              >Password
              <span class="required-field">*</span>
            </label>
            <ces-textbox
              inputType="password"
              placeholder="Enter new password"
              formControlName="newPassword"
              iconPosition="left"
              id="reset_new"
              icon="icon-password"
              size="medium"
              (onChange)="passwordChange()"
            >
            </ces-textbox>
            <div class="password-validation-message">
              <div class="password-validation-message-title">Must contain:</div>
              <ul>
                <li
                  [ngClass]="{
                    'invalid-input-item': this.customV.lengthInvalid,
                    'valid-input-item': this.customV.lengthInvalid === false
                  }"
                >
                  <i
                    class="icon"
                    [ngClass]="{
                      'icon-close': this.customV.lengthInvalid,
                      'icon-tick': this.customV.lengthInvalid === false
                    }"
                  ></i
                  >At least 9 characters
                </li>
                <li
                  [ngClass]="{
                    'invalid-input-item': this.customV.upperCaseInvalid,
                    'valid-input-item': this.customV.upperCaseInvalid === false
                  }"
                >
                  <i
                    class="icon"
                    [ngClass]="{
                      'icon-close': this.customV.upperCaseInvalid,
                      'icon-tick': this.customV.upperCaseInvalid === false
                    }"
                  ></i
                  >At least 1 upper case letter (A-Z)
                </li>
                <li
                  [ngClass]="{
                    'invalid-input-item': this.customV.lowerCaseInvalid,
                    'valid-input-item': this.customV.lowerCaseInvalid === false
                  }"
                >
                  <i
                    class="icon"
                    [ngClass]="{
                      'icon-close': this.customV.lowerCaseInvalid,
                      'icon-tick': this.customV.lowerCaseInvalid === false
                    }"
                  ></i
                  >At least 1 lower case letter (a-z)
                </li>
                <li
                  [ngClass]="{
                    'invalid-input-item': this.customV.numberInvalid,
                    'valid-input-item': this.customV.numberInvalid === false
                  }"
                >
                  <i
                    class="icon"
                    [ngClass]="{
                      'icon-close': this.customV.numberInvalid,
                      'icon-tick': this.customV.numberInvalid === false
                    }"
                  ></i
                  >At least 1 number (0-9)
                </li>
                <li
                  [ngClass]="{
                    'invalid-input-item': this.customV.specialCharInvalid,
                    'valid-input-item': this.customV.specialCharInvalid === false
                  }"
                >
                  <i
                    class="icon"
                    [ngClass]="{
                      'icon-close': this.customV.specialCharInvalid,
                      'icon-tick': this.customV.specialCharInvalid === false
                    }"
                  ></i
                  >At lease 1 special character (!@#$%^&*?)
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="ces-form-group required">
            <label class="ces-label ces-label-2 ces-text-medium"
              >Repeat Password
              <span class="required-field">*</span>
            </label>
            <ces-textbox
              inputType="password"
              placeholder="Enter repeat password"
              formControlName="confirmPassword"
              iconPosition="left"
              id="reset_new"
              icon="icon-password"
              size="medium"
              (onChange)="passwordChange()"
            >
            </ces-textbox>
          </div>
        </div>
      </div>
      <div class="row text-end">
        <div
          class="input-helper invalid-input-message"
          *ngIf="loadingConfig.change.errorMessage"
        >
          {{ loadingConfig.change.errorMessage }}
        </div>
      </div>
    </form>
  </div>
  <!--modal footer-->
  <div class="k-dialog-buttongroup k-actions k-actions-stretched">
    <button
      class="ces-button ces-button-ghost ces-button-medium"
      (click)="dismiss()"
    >
      <span class="button-label">Cancel</span>
    </button>

    <ces-button
      btnClass="job-submit-btn"
      label="Submit"
      (onClick)="onSubmit()"
      size="medium"
      status="primary"
      [loading]="loadingConfig.change.loading"
      [disabled]="loadingConfig.change.submitted || !pwdForm.valid"
    ></ces-button>
  </div>
</div>

<!--end modal custom wrapper-->
